import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { CreateFormsService } from '@bo-client/activation-management/shared/forms/create-forms.service';
import {
  PlaceInServiceModel,
  PlaceInServiceModelForm
} from '@bo-client/activation-management/grid-registration/model/grid-registration.model';

@Injectable({
  providedIn: 'root'
})
export class CreateFormsGrPlaceinserviceService {
  public form = new FormGroup({}, { updateOn: 'submit' });

  constructor(private fb: FormBuilder, private createFormsService: CreateFormsService) {}

  createPlaceInServiceRequestForm(
    data: PlaceInServiceModel,
    mastrValidationActive?: boolean
  ): PlaceInServiceModelForm {
    return this.fb.group({
      effectiveActivePowerMax: [data.effectiveActivePowerMax],
      effectiveApparentPowerMax: [data.effectiveApparentPowerMax],
      effectiveModulePowerWatt: [data.effectiveModulePowerWatt],
      effectiveAndRequestedValuesMatch: [data.effectiveAndRequestedValuesMatch],
      invoiceMeteringCheckDone: [data.invoiceMeteringCheckDone],
      vdeCertificateExists: [data.vdeCertificateExists],
      powerDirectionSensorCheckDone: [data.powerDirectionSensorCheckDone],
      vdeArN4100_55_CertificateExists: [data.vdeArN4100_55_CertificateExists],
      powerProtectionCertificateExists: [data.powerProtectionCertificateExists],
      factorCosphiCheck: [data.factorCosphiCheck],
      naProtection: [data.naProtection],
      overvoltageProtectionType: [data.overvoltageProtectionType],
      overvoltageReleaseTestDone: [data.overvoltageReleaseTestDone],
      triggerCircuitTestDone: [data.triggerCircuitTestDone],
      pMonitoringExists: [data.pMonitoringExists],
      paveTestDone: [data.paveTestDone],
      effectivePave: [data.effectivePave],
      eegConfirmation: [data.eegConfirmation],
      flawlessFunctionGuarantee: [data.flawlessFunctionGuarantee],
      symmetryConditions: [data.symmetryConditions],
      addedGenerationL1: [data.addedGenerationL1],
      existingGenerationL1: [data.existingGenerationL1],
      addedGenerationL2: [data.addedGenerationL2],
      existingGenerationL2: [data.existingGenerationL2],
      addedGenerationL3: [data.addedGenerationL3],
      existingGenerationL3: [data.existingGenerationL3],
      placeInServiceDatum: this.fb.control({
        value: data.placeInServiceDatum,
        disabled: !!mastrValidationActive
      }),
      vdeConditions: [data.vdeConditions],
      customerAuthorization: [data.customerAuthorization]
    });
  }

  createPlaceInServiceConfirmationForm() {
    return this.createFormsService.formConfirmation();
  }
}
